import AfterDive from '@luketclancy/otterly/after_dive.js'
AfterDive.inner_html = AfterDive.innerHtml
AfterDive.set_data = AfterDive.setData
AfterDive._morphOpts = (opts) => { //this is used externally
	let perm = opts['permanent']
	let ign = opts['ignore']
	if(opts == null) {
		return {}
	}
	if(ign != null || perm != null) {
		let m_parse_p = (selector, from, to) => {
			if(from.matches(selector) && to.matches(selector)) {
				return false
			}
			return true
		}
		let m_parse_i = (selector, from, to) => {
			if(from.matches(selector) || to.matches(selector)) {
				return false
			}
			return true
		}
		let m_parse = (selectors, inner_parse, from, to) => {
			if(!(Array.isArray(selectors))) {
				selectors = [selectors]
			}
			for(let y = 0; y < selectors.length; y++) {
				if(!inner_parse(selectors[y], from, to)){
					return false
				}
			}
			return true
		}
		opts['onBeforeElChildrenUpdated'] = (from, to) => {
			if(! m_parse(ign, m_parse_i, from, to) ) {
				return false
			}
			if(! m_parse(perm, m_parse_p, from, to) ) {
				return false
			}
			return true
		}
	}
}
export default AfterDive